<template>
  <div
    ref="loading"
    class="zoox-loader"
    :style="{height: size + 'px', width: size + 'px'}"
  >
    <div class="zoox-loader-container">
      <div><div></div></div>
      <div><div></div></div>
      <div><div></div></div>
      <div><div></div></div>
      <div><div></div></div>
      <div><div></div></div>
      <div><div></div></div>
      <div><div></div></div>
    </div>
  </div>
</template>

<script>
import {hexToRgb} from '../../../utils/colors'

/**
 * Componente utilizado para exibir carregamento de páginas. Indicado
 * para carregamentos globais e locais dentro das rotas também.
 * @displayName Loading
 */
export default {
  name: 'ZLoading',
  props: {
    /**
     * Tamanho em pixels do container do loader.
     */
    size: {
      type: Number,
      default: 200,
    },
    /**
     * Cor base do design system para utilizar no loading (definida no mounted)
     *
     * @values lightblue,midblue,darkblue,lightgreen,darkgreen,magenta,red,orange,yellow,lightgreen,darkgreen,purple
     */
    baseColor: {
      type: String,
      default: '',
    },
    /**
     * Array (8 itens) de cores para serem colocadas no loader.
     */
    colors: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const bodyStyles = this.$refs.loading.style

    if (this.colors.length === 8) {
      for (let i = 0; i < this.colors.length; ++i) {
        const variation = i + 1 + '00'

        bodyStyles.setProperty('--basecolor-' + variation, this.colors[i])
      }
      return
    }

    if (this.baseColor !== '' && /^#/.test(this.baseColor)) {
      const {r, g, b} = hexToRgb(this.baseColor)

      for (let i = 0; i < 8; ++i) {
        const variation = i + 1 + '00'
        const a = (i + 2) / 10

        bodyStyles.setProperty(
          '--basecolor-' + variation,
          `rgba(${r},${g},${b},${a})`
        )
      }
      return
    }

    if (this.baseColor !== '') {
      const variations = [
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
      ]

      for (let variation of variations) {
        bodyStyles.setProperty(
          '--basecolor-' + variation,
          `var(--${this.baseColor + '-' + variation})`
        )
      }
    }
  },
}
</script>

<style scoped type="text/css">
@keyframes zoox-loader-container {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.zoox-loader {
  --basecolor-100: var(--midblue-100);
  --basecolor-200: var(--midblue-200);
  --basecolor-300: var(--midblue-300);
  --basecolor-400: var(--midblue-400);
  --basecolor-500: var(--midblue-500);
  --basecolor-600: var(--midblue-600);
  --basecolor-700: var(--midblue-700);
  --basecolor-800: var(--midblue-800);
}

.zoox-loader-container > div {
  position: absolute;
  width: 12px;
  height: 12px;
  animation: zoox-loader-container 1.4925373134328357s
    cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 100px 100px;
}

.zoox-loader-container > div > div {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.zoox-loader-container div:nth-child(0) {
  animation-delay: 0s;
}

.zoox-loader-container div:nth-child(0) > div {
  background: var(--basecolor-100);
  transform: translate(141.6012004174741px, 130.52568574052324px);
}

.zoox-loader-container div:nth-child(1) {
  animation-delay: -0.062s;
}

.zoox-loader-container div:nth-child(1) > div {
  background: var(--basecolor-200);
  transform: translate(130.52568574052324px, 141.6012004174741px);
}

.zoox-loader-container div:nth-child(2) {
  animation-delay: -0.125s;
}

.zoox-loader-container div:nth-child(2) > div {
  background: var(--basecolor-300);
  transform: translate(116.9610059419054px, 149.4327719506772px);
}

.zoox-loader-container div:nth-child(3) {
  animation-delay: -0.187s;
}

.zoox-loader-container div:nth-child(3) > div {
  background: var(--basecolor-400);
  transform: translate(101.8315715332031px, 153.4866916824286px);
}

.zoox-loader-container div:nth-child(4) {
  animation-delay: -0.25s;
}

.zoox-loader-container div:nth-child(4) > div {
  background: var(--basecolor-500);
  transform: translate(86.16842846679691px, 153.4866916824286px);
}

.zoox-loader-container div:nth-child(5) {
  animation-delay: -0.312s;
}

.zoox-loader-container div:nth-child(5) > div {
  background: var(--basecolor-600);
  transform: translate(71.03899405809463px, 149.43277195067722px);
}

.zoox-loader-container div:nth-child(6) {
  animation-delay: -0.375s;
}

.zoox-loader-container div:nth-child(6) > div {
  background: var(--basecolor-700);
  transform: translate(57.47431425947676px, 141.6012004174741px);
}

.zoox-loader-container div:nth-child(7) {
  animation-delay: -0.437s;
}

.zoox-loader-container div:nth-child(7) > div {
  background: var(--basecolor-800);
  transform: translate(46.398799582525896px, 130.52568574052324px);
}

.zoox-loader {
  display: inline-block;
  overflow: hidden;
  background: transparent;
}

.zoox-loader-container {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}

.zoox-loader-container div {
  box-sizing: content-box;
}
</style>
